// extracted by mini-css-extract-plugin
export default {"body":"consumer_body__XdoJJ","root":"consumer_root__jqWYk","consumer":"consumer_consumer__0qoxw","alarm":"consumer_alarm__xHl71"};